import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

interface ModalProps {
  isOpen: boolean;
  width: string;
  height: string;
  onClose: () => void;
  children: JSX.Element;
}

const contentStyle = {
  position: 'fixed' as 'fixed',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  display: 'flex'
};

export const SubtopicModal = ({
  isOpen,
  width,
  height,
  onClose,
  children
}: ModalProps) => {
  return (
    <div>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby='subtopic-position-canvas'
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Box sx={{ ...contentStyle, width, height }}>{children}</Box>
      </Modal>
    </div>
  );
};
